<template>
  <el-dialog
    v-bind="$attrs"
    :area="[800, 550]"
    title="导入历史记录"
    top="middle"
    no-scrollbar
    v-on="$listeners"
  >
    <!-- 列表 -->
    <el-table
      ref="detail"
      v-loading="isLoading"
      :data="table.data"
      :show-loading="false"
      border
      tooltip-effect="dark"
      height="398"
      style="width: 100%;"
      show-overflow-title
    >
      <el-table-column label="时间" min-width="120" prop="importTime"></el-table-column>
      <!-- 账号 -->
      <el-table-column label="账号" min-width="100" prop="userName" />
      <!-- 结果 -->
      <el-table-column label="结果" min-width="250" prop="index">
        <template slot-scope="scope">{{ showImportResult(scope.row) }}</template>
      </el-table-column>
      <!-- 详情 -->
      <el-table-column label="详情" min-width="50" prop="index">
        <template slot-scope="scope">
          <el-button
            title="详情"
            type="iconButton"
            icon="h-icon-details"
            @click="handlerShowDetail(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 列表分页 -->
    <!-- <el-pagination
      :page-sizes="[10, 20, 30, 50, 100]"
      :page-size="table.params.pageSize"
      :current-page="table.params.pageNo"
      layout="total, sizes, prev, pager, next, jumper"
      :total="table.total"
      @current-change="currentChange"
      @size-change="sizeChange"
    ></el-pagination> -->
    <!-- 对话框操作 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeHandler">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import api from '@/api/companyManage.api'

export default {
  name: 'CompanyImportRecords',
  data() {
    return {
      isLoading: false, // 加载标识
      /* 列表 */
      table: {
        data: [],
        params: {
          pageNo: 1,
          pageSize: 10
        },
        total: 0
      },
      detailPageRouter: '/emms/CompanyManage/CompanyImportDetail'
    }
  },

  watch: {
    '$attrs.visible'(val) {
      // 渲染之前再加载列表数据
      val && this.getTable()
    }
  },

  methods: {
    // @description: 表格分页
    // ------------------------------------------------------------------------------------------------
    /**
     * @Author: zhuxiankang
     * @Date:   2018-02-09 16:54:11
     * @Desc:   table显示的当前页变化时重新获取数据
     * @Parm:
     */
    currentChange(pageNo) {
      this.table.params.pageNo = pageNo
      this.getTable()
    },

    /**
     * @Author: zhuxiankang
     * @Date:   2018-02-09 17:00:09
     * @Desc:   table显示的size变化时重新获取数据
     * @Parm:
     */
    sizeChange(pageSize) {
      this.table.params.pageSize = pageSize
      this.getTable()
    },

    /**
     * @Author: zhuxiankang
     * @Date:   2018-02-28 16:49:37
     * @Desc:   获取日志详情列表数据和分页数据
     * @Parm:
     */
    async getTable() {
      try {
        this.isLoading = true
        const { data } = await api.importResult(this.table.params)
        this.table.total = data.total
        this.table.data = data.rows
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },

    /**
     * @Author: zhuxiankang
     * @Date:   2018-03-12 14:39:15
     * @Desc:   显示导入结果
     * @Parm:   row -> 表格行数据
     */
    showImportResult(row) {
      if (!row.successCount) {
        return row.totalCount + '条数据全部导入失败。'
      } else if (row.successCount === row.totalCount) {
        return row.successCount + '条数据全部导入成功。'
      } else {
        return `${row.successCount}条数据导入成功，${row.totalCount -
          row.successCount}条数据导入失败。`
      }
    },

    /**
     * @Author: zhuxiankang
     * @Date:   2018-03-12 14:48:55
     * @Desc:   显示导入详情
     * @Parm:   row -> 表格行数据
     */
    handlerShowDetail(row) {
      window.open(`${this.detailPageRouter}?type=IMPORT&batchUUid=${row.batchUuid}`)
    },
    /*
     * @Author: jiangyan6
     * @Date: 2019-08-16 14:42:48
     * @Desc: 点击关闭按钮的处理方法
     * @param:
     * @return:
     */
    closeHandler() {
      this.$emit('update:visible', false)
    }
  }
}
</script>
